enum Environment {
  Development = "development",
  Local = "local",
  Production = "production",
}

export default Environment;
